import * as React from "react";
import { styled } from "@mui/material/styles";
import { Message } from "../../types";
import { useParticipantStatus } from "../../participantStatus";
import { containerSpacing } from "./styles";
import { messageContentRenderers } from "./messageContentRenderers";
import TimeStamp from "./TimeStamp";
import { getItemHoverColor } from "../widgets";

const MessageContainer = styled("div")(({ theme }) => ({
    padding: `0.2em ${containerSpacing}`,
    transition: "background-color 0.2s",
    "&:hover": {
        backgroundColor: getItemHoverColor(theme),
    },
}));

const Name = styled("span")({
    fontSize: "1.1em",
    fontWeight: "bold",
    marginRight: "0.5em",
    flexGrow: 1,
});

const Header = styled("div")({
    display: "flex",
    alignItems: "center",
});

const MessageGroup = ({ messages }: { messages: Message[] }) => {
    const participantStatus = useParticipantStatus(messages[0].sender);

    const name = participantStatus.name ?? messages[0].sender.substr(0, 10);

    if (messages.filter((m) => Object.keys(messageContentRenderers).includes(m.contentType)).length === 0) return null;

    return (
        <MessageContainer>
            <Header>
                <Name>{name}</Name>
                <TimeStamp date={messages[0].date} />
            </Header>
            {messages.map((msg) => {
                const Renderer = messageContentRenderers[msg.contentType];
                if (!Renderer) return null;
                return <Renderer key={msg.messageId} message={msg} />;
            })}
        </MessageContainer>
    );
};

export default MessageGroup;
